import { render } from "./Navbar.vue?vue&type=template&id=702c0620"
import script from "./Navbar.vue?vue&type=script&lang=js"
export * from "./Navbar.vue?vue&type=script&lang=js"

import "./Navbar.vue?vue&type=style&index=0&id=702c0620&lang=css"
script.render = render

export default script